import {BoundingBoxClassControl} from '@wandb/weave/common/components/MediaCard';
import {
  DEFAULT_ALL_MASK_CONTROL,
  DEFAULT_CLASS_MASK_CONTROL,
} from '@wandb/weave/components/Panel2/ImageWithOverlays';
import produce from 'immer';
import {get, setWith} from 'lodash';
import React from 'react';

import {segmentationMaskColor} from '../../../../../../util/media';
import {OverlaysTable} from '../../common/OverlaysTable';
import {OverlaysTableRow} from '../../common/OverlaysTableRow';
import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';
import {BoundingBoxStrokeTypeSelector} from './BoundingBoxStrokeTypeSelector';

export const BoundingBoxClasses = ({
  boxKey,
  mediaKey,
  boxQueryRegex,
}: {
  boxKey: string;
  mediaKey: string;
  boxQueryRegex: RegExp;
}) => {
  const {allBoxes, updateConfig, config} = useMediaSettingsDrawerContext();
  const boundingBoxConfig = config.boundingBoxConfig ?? {};
  const classDict = allBoxes[mediaKey][boxKey].value;
  const allConfigPath = ['toggles', mediaKey, boxKey, 'all'];
  const allBoxControl: BoundingBoxClassControl =
    get(boundingBoxConfig, allConfigPath) ?? DEFAULT_ALL_MASK_CONTROL;

  const update = (
    newControl: Partial<BoundingBoxClassControl>,
    configPath: string[],
    boxControl: BoundingBoxClassControl
  ) => {
    const newConfig = produce(boundingBoxConfig, draft => {
      return setWith(draft, configPath, {...boxControl, ...newControl}, Object);
    });
    updateConfig({boundingBoxConfig: newConfig});
  };

  return (
    <OverlaysTable
      isAllVisible={!allBoxControl.disabled}
      setIsAllVisible={() =>
        update(
          {disabled: !allBoxControl.disabled},
          allConfigPath,
          allBoxControl
        )
      }
      title={boxKey}
      rightContent={
        <BoundingBoxStrokeTypeSelector
          mediaKey={mediaKey}
          boxKey={boxKey}
          boxConfig={boundingBoxConfig}
          updateConfig={updateConfig}
        />
      }>
      {Object.entries(classDict).reduce<JSX.Element[]>((acc, [k, name]) => {
        if (!name.match(boxQueryRegex)) {
          return acc; // Skip if it doesn't match
        }
        const configPath = ['toggles', mediaKey, boxKey, k];

        const boxControl: BoundingBoxClassControl =
          get(boundingBoxConfig, configPath) ?? DEFAULT_CLASS_MASK_CONTROL;

        const onClickHandler = () =>
          update({disabled: !boxControl.disabled}, configPath, boxControl);

        acc.push(
          <OverlaysTableRow
            data-test="bounding-box-class-row"
            key={mediaKey + boxKey + name}
            title={name}
            isVisible={!boxControl.disabled}
            setIsVisible={onClickHandler}
            color={segmentationMaskColor(Number(k))}
          />
        );

        return acc;
      }, [])}
    </OverlaysTable>
  );
};
